const locales = {
  en: {
    settings: "Settings",
    language: "Language",
    chartView: "Default Chart View",
    share: "Share the app",
    rate: "Rate this App",
    about: "About",
    logout: "Logout",
    others: "Others",
    admin: "Admin Dashboard",
    sub: "Subscribe / Support",
    subDesc: "Unlock premium features and support Spendora!",
    total_time: "Total",
    most_active_day: "Most Active Day",
    top_category: "Top Category",
    highlight_activity: "Highlight",
    time_by_category: "Time Distribution by Category",
    no_activities: "No activities found.",
    daily_summary: "Daily Time Summary",
    monthly_summary: "Monthly Time Summary",
    no_data: "No data.",
    tip1: "Tip: Set a daily goal and check your progress every day.",
    tip2: "Don't forget to balance work with quality rest.",
    tip3: "Logging activities helps you build healthy habits.",
    tip4: "Try recurring activities for better consistency!",
    tip5: "Spendora cares about your wellness. 💙",
    all: "All",
    search: "Search activity…",
    loading: "Loading...",
    recurring: "Recurring",
    edit: "Edit",
    delete: "Delete",
    confirm_delete: "Are you sure you want to delete this activity?",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    sun: "Sun",
    add_activity: "Add Activity",
    edit_activity: "Edit Activity",
    delete_activity: "Delete Activity",
    activities: "Activities",
    no_activities_today: "No activities for this day",
    added: "Activity added!",
    updated: "Activity updated!",
    deleted: "Activity deleted.",
    undo: "Undo",
    duration_placeholder: "Duration (auto from above, or manual e.g. 1h 30min)",
    note_optional: "Note (optional)",
    start_time: "Start time",
    end_time: "End time",
    repeat: "Repeat this activity",
    repeat_every: "Repeat every",
    days: "Day(s)",
    weeks: "Week(s)",
    months: "Month(s)",
    recur_end_label: "End date (optional)",
    overnight: "This activity goes overnight to the next day.",
    cancel: "Cancel",
    save: "Save",
    save_failed: "Save failed, please try again",
    error_activity_name: "Please enter activity name.",
    error_start_end_same: "Start and end time cannot be the same.",
    error_duration: "Please enter a valid duration (e.g., 1h, 45min, 08:00-09:30).",
    error_recur_type: "Please select recurrence type.",
    error_recur_day: "Please select at least one weekday.",
    error_recur_end: "End date should not be before start date.",
    support_desc: "Support the app, unlock all features, and keep us going!",
    premium_features: "Premium Features:",
    premium_unlimited_history: "Unlimited activity history",
    premium_export: "Export data as CSV",
    premium_themes: "Add/Edit Categories",
    premium_support: "Special Functions",
    support_us: "Subscribe or Support:",
    mood_prompt: "How did you feel during this activity?",
    mood_happy: "Great",
    mood_calm: "Calm",
    mood_neutral: "Neutral",
    mood_sad: "Sad",
    mood_angry: "Angry",
    note_placeholder: "Write your thoughts or feelings about this activity (optional)",
    tab_summary: "Summary",
    tab_goal: "Goal",
    tab_trend: "Trend",
    tab_mood: "Mood",
    new_record: "Started tracking!",
    timer_work_title: "⏳ Timing",
    timer_break_title: "🍵 Break",
    timer_start: "Start",
    timer_cancel: "Cancel",
    timer_pause: "Pause",
    timer_resume: "Resume",
    timer_stop: "Stop",
    timer_work: "Work",
    timer_break: "Break",
    timer_minute: "min",
    timer_notify_break: "Session complete! Time for a {min}-minute break",
    timer_notify_resume: "Break finished! Ready for next session",
    pomodoro_round: "Pomodoro round",
    activity_placeholder: "Activity, e.g. Meeting, Reading, Walking",
    start_break: "Start Break",
    skip_break: "Skip Break",
    timer_reset_default: "Reset to Recommend",
    start_work: "Start Next Work",
    stop_pomodoro: "Stop",
    notification_message: "Notification Message",
    notification_preview: "Preview Notification",
    notification_category: "Category",
    notification_sound: "Notification Sound",
    notification_everyday: "Every day",
    notification_weekdays: "Specific days",
    notification_specific_date: "Specific date",
    notification_date_range: "Date range",
    notification_from: "From",
    notification_to: "To",
    notification_placeholder: "e.g. Take a break, or You got this! ✨",
    notification_categories: ["Activity", "Habit", "Motivation", "Other"],
    notification_sounds: ["Default", "Chime", "Bell", "Silent"],
    special_setting: "Special Setting",
    current_age: "Current Age",
    current_age_placeholder: "Enter your current age (years)",
    birth_year: "You were born in {year}",
    target_age: "Target Age",
    target_age_placeholder: "Enter age you wish to reach (max {max} years)",
    target_age_invalid: "Target age must be higher than current and ≤ {max}",
    hours_left: "You have {hours} hours left",
  },
  th: {
    settings: "ตั้งค่า",
    language: "ภาษา",
    chartView: "กราฟเริ่มต้น",
    share: "แชร์แอป",
    rate: "ให้คะแนนแอป",
    about: "เกี่ยวกับ",
    logout: "ออกจากระบบ",
    others: "อื่น ๆ",
    admin: "แดชบอร์ดผู้ดูแล",
    sub: "สมัครสมาชิก / สนับสนุน",
    subDesc: "ปลดล็อกฟีเจอร์พรีเมียมและสนับสนุน Spendora!",
    total_time: "รวมเวลาที่บันทึก",
    most_active_day: "วันที่ทำกิจกรรมมากที่สุด",
    top_category: "หมวดหมู่ที่ทำมากสุด",
    highlight_activity: "กิจกรรมเด่น",
    time_by_category: "สัดส่วนเวลาต่อหมวดหมู่",
    no_activities: "ยังไม่มีการบันทึกกิจกรรม",
    daily_summary: "สรุปเวลากิจกรรมรายวัน",
    monthly_summary: "สรุปเวลากิจกรรมรายเดือน",
    no_data: "ไม่มีข้อมูล",
    tip1: "เคล็ดลับ: ตั้งเป้าหมายประจำวันแล้วเช็คความคืบหน้า",
    tip2: "อย่าลืมบาลานซ์การทำงานกับการพักผ่อน",
    tip3: "จดกิจกรรมบ่อย ๆ เพื่อสร้างสุขนิสัยที่ดี",
    tip4: "ลองตั้งกิจกรรมประจำ จะช่วยให้สม่ำเสมอขึ้น!",
    tip5: "Spendora ห่วงใยสุขภาพใจคุณ 💙",
    all: "ทั้งหมด",
    search: "ค้นหากิจกรรม…",
    loading: "กำลังโหลด...",
    recurring: "กิจกรรมประจำ",
    edit: "แก้ไข",
    delete: "ลบ",
    confirm_delete: "คุณแน่ใจว่าต้องการลบกิจกรรมนี้หรือไม่?",
    mon: "จ.",
    tue: "อ.",
    wed: "พ.",
    thu: "พฤ.",
    fri: "ศ.",
    sat: "ส.",
    sun: "อา.",
    add_activity: "เพิ่มกิจกรรม",
    edit_activity: "แก้ไขกิจกรรม",
    delete_activity: "ลบกิจกรรม",
    activities: "กิจกรรม",
    no_activities_today: "ยังไม่มีกิจกรรมในวันนี้",
    added: "เพิ่มกิจกรรมแล้ว!",
    updated: "บันทึกการแก้ไขแล้ว!",
    deleted: "ลบกิจกรรมแล้ว",
    undo: "ย้อนกลับ",
    duration_placeholder: "ระยะเวลา (อัตโนมัติจากเวลา หรือใส่เอง เช่น 1ชม. 30นาที)",
    note_optional: "หมายเหตุ (ถ้ามี)",
    start_time: "เวลาเริ่มต้น",
    end_time: "เวลาสิ้นสุด",
    repeat: "ทำซ้ำกิจกรรมนี้",
    repeat_every: "ทำซ้ำทุก ๆ",
    days: "วัน",
    weeks: "สัปดาห์",
    months: "เดือน",
    recur_end_label: "วันที่สิ้นสุด (ถ้ามี)",
    overnight: "กิจกรรมนี้ข้ามคืนไปวันถัดไป",
    cancel: "ยกเลิก",
    save: "บันทึก",
    save_failed: "บันทึกไม่สำเร็จ กรุณาลองใหม่",
    error_activity_name: "กรุณากรอกชื่อกิจกรรม",
    error_start_end_same: "เวลาเริ่มต้นและสิ้นสุดต้องไม่เหมือนกัน",
    error_duration: "กรุณากรอกระยะเวลาให้ถูกต้อง (เช่น 1ชม., 45นาที, 08:00-09:30)",
    error_recur_type: "กรุณาเลือกรูปแบบการทำซ้ำ",
    error_recur_day: "กรุณาเลือกวันอย่างน้อย 1 วัน",
    error_recur_end: "วันสิ้นสุดต้องไม่ก่อนวันเริ่มต้น",
    support_desc: "สนับสนุนแอป ปลดล็อกทุกฟีเจอร์ และช่วยให้เราไปต่อ!",
    premium_features: "สิทธิพิเศษสำหรับสมาชิก:",
    premium_unlimited_history: "ดูประวัติกิจกรรมได้ไม่จำกัด",
    premium_export: "ส่งออกข้อมูลเป็น CSV",
    premium_themes: "เพิ่ม/แก้ไขหมวดหมู่กิจกรรม",
    premium_support: "ฟังก์ชันพิเศษ",
    support_us: "สมัครสมาชิกหรือสนับสนุนเรา:",
    mood_prompt: "วันนี้กิจกรรมนี้ทำให้คุณรู้สึกยังไง?",
    mood_happy: "ดีมาก",
    mood_calm: "สบายใจ",
    mood_neutral: "เฉย ๆ",
    mood_sad: "เศร้า",
    mood_angry: "หงุดหงิด",
    note_placeholder: "บันทึกความรู้สึกหรือสิ่งที่อยากบอกตัวเองเกี่ยวกับกิจกรรมนี้ (จะเว้นว่างก็ได้)",
    tab_summary: "ภาพรวม",
    tab_goal: "เป้าหมาย",
    tab_trend: "เทรนด์",
    tab_mood: "อารมณ์",
    new_record: "เริ่มต้นการบันทึก!",
    timer_work_title: "⏳ กำลังจับเวลา",
    timer_break_title: "🍵 พักผ่อน",
    timer_start: "เริ่ม",
    timer_cancel: "ยกเลิก",
    timer_pause: "หยุดชั่วคราว",
    timer_resume: "นับต่อ",
    timer_stop: "หยุด",
    timer_work: "โฟกัส",
    timer_break: "พัก",
    timer_minute: "นาที",
    timer_notify_break: "ครบเซสชั่น! ถึงเวลาพัก {min} นาที",
    timer_notify_resume: "หมดเวลาพัก! พร้อมเริ่มรอบใหม่",
    pomodoro_round: "รอบ Pomodoro",
    activity_placeholder: "กิจกรรม เช่น ประชุม, อ่านหนังสือ, เดินเล่น",
    start_break: "เริ่มพัก",
    skip_break: "ข้ามพัก",
    timer_reset_default: "คืนค่าเป็นค่าที่แนะนำ",
    start_work: "เริ่มโฟกัสรอบถัดไป",
    stop_pomodoro: "หยุด",
    notification_message: "ข้อความแจ้งเตือน",
    notification_preview: "ตัวอย่างแจ้งเตือน",
    notification_category: "หมวด",
    notification_sound: "เสียงแจ้งเตือน",
    notification_everyday: "ทุกวัน",
    notification_weekdays: "เลือกวัน",
    notification_specific_date: "เลือกวันเดียว",
    notification_date_range: "เลือกช่วงวัน",
    notification_from: "ตั้งแต่",
    notification_to: "ถึง",
    notification_placeholder: "เช่น พักสายตาบ้างนะ หรือ สู้ ๆ ✨",
    notification_categories: ["กิจกรรม", "นิสัย", "แรงบันดาลใจ", "อื่น ๆ"],
    notification_sounds: ["ค่าเริ่มต้น", "เสียงกระดิ่ง", "ระฆัง", "เงียบ"],
    special_setting: "ตั้งค่าพิเศษ",
    current_age: "อายุปัจจุบัน",
    current_age_placeholder: "ใส่อายุปัจจุบัน (ปี)",
    birth_year: "คุณเกิดปี {year}",
    target_age: "อายุที่คิดว่าจะอยู่ถึง",
    target_age_placeholder: "ใส่อายุที่คาดว่าจะอยู่ถึง (สูงสุด {max} ปี)",
    target_age_invalid: "ใส่อายุต้องมากกว่าอายุปัจจุบัน และไม่เกิน {max} ปี",
    hours_left: "คุณเหลือเวลาอีก {hours} ชั่วโมง",
  },
};

export default locales;